export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:mounted', () => {
    useLordicon().catch(() => {
      // Error already logged in useLordicon; suppress unhandled rejection.
    })
  })
})
